import { IconCalendarStats } from '@tabler/icons-react'
import styled, { css, CSSProperties } from 'styled-components'

import { TimezonedDate } from '@/context/timezoneContext'

const DueDateLabel = styled.span<{ overdue?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;

  ${({ theme, overdue }) =>
    overdue &&
    css`
      color: ${theme.colour.semantic.errorDark};
      font-weight: 500;
    `}
`

type DueDateProps = {
  dueDate: string
  overdue?: boolean
  justifyContent?: CSSProperties['justifyContent']
  className?: string
}

export const DefectDueDate: React.FC<DueDateProps> = ({
  dueDate,
  overdue,
  justifyContent,
  className,
}) => {
  if (!dueDate) return null

  return (
    <DueDateLabel
      overdue={overdue}
      style={{ justifyContent }}
      className={className}
    >
      <IconCalendarStats size={16} />
      Due <TimezonedDate date={dueDate} includeTime={false} />
    </DueDateLabel>
  )
}
